<template>
    <section class="main">
        <div v-show="isLoading">
        <v-page-loading />
        </div>
         <div v-show="!isLoading">
            <v-page-header :title="getPageTile" />

            <div v-show="hasLoadingError">
                <div class="grid-container">
                <p class="text-center">{{ loadingError }}</p>
                </div>
            </div>

            <v-form-message
                type="success"
                id="form-success"
                :message="mixingplantCreateOrUpdateSuccessMessage"
                :autoCloseTimeout="1000" />

            <v-form-message
                type="error"
                id="form-error"
                :message="mixingplantCreateOrUpdateErrorMessage"
                :autoCloseTimeout="5000" />

            <div class="grid-container">
                <div class="grid-x">
                    <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                        <v-action-buttons
                            :items="getActionButtons"
                            @actionClicked="onClickAction"
                        />
                        <div class="box">
                            <div class="form-group--wrapper">
                                <div class="form-block">
                                    <div class="grid-x grid-margin-x">
                                        <div class="cell small-12">
                                            <div
                                                class="form-group form-group--required"
                                                :class="{ 'form-group--error' : $v.object.name.$error }"
                                            >
                                                <label for="form-field-company-name">{{ $t('customers.company_name') }}</label>
                                                <input required type="text" id="form-field-company-name" name="name" class="form-control" placeholder="Name eingeben" v-model="object.name" />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Location -->
                                    <div class="grid-x grid-margin-x u-extra-large-margin--top">
                                        <div class="cell medium-8">
                                            <div class="grid-x grid-margin-x">
                                                <div class="cell medium-8">
                                                    <div
                                                        class="form-group form-group--required"
                                                        :class="{ 'form-group--error' : $v.object.address.street.$error }"
                                                    >
                                                        <label for="form-field-company-address-street">Straße</label>
                                                        <input required type="text" id="form-field-company-address-street" name="address" class="form-control" placeholder="Straße eingeben" v-model="object.address.street" />
                                                    </div>
                                                </div>
                                                <div class="cell medium-4">
                                                    <div
                                                        class="form-group form-group--required"
                                                        :class="{ 'form-group--error' : $v.object.address.housenumber.$error }"
                                                    >
                                                        <label for="form-field-company-housenumber">Hausnummer</label>
                                                        <input required type="text" id="form-field-company-housenumber" name="address" class="form-control" placeholder="Hausnummer eingeben" v-model="object.address.housenumber" />
                                                    </div>
                                                </div>

                                                <div class="cell medium-6 large-4">
                                                    <div
                                                        class="form-group form-group--small form-group--required"
                                                        :class="{ 'form-group--error' : $v.object.address.zipcode.$error }"
                                                    >
                                                        <label for="form-field-zipcode">{{ $t('form.zipcode') }}</label>
                                                        <input type="text" id="form-field-zipcode" name="zipcode" class="form-control" :class="{'loading-spinner--input' : geocodeLoading}" :placeholder="$t('form.zipcode.plc')" v-model="object.address.zipcode" @keyup="onChangeZipcode" />
                                                    </div>
                                                    <div class="form-group" v-if="geocodeObject.zipcode.length > 1">
                                                        <select name="zipcode_list" class="form-control form-control--select" @change="onSelectZipcode">
                                                            <option value="">{{ $t('form.zipcode.choose')}}</option>
                                                            <option v-for="item in geocodeObject.zipcode" :value="item.zipcode">
                                                                {{ item.zipcode }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="cell medium-6 large-4">
                                                    <div
                                                        class="form-group form-group--small form-group--required"
                                                        :class="{ 'form-group--error' : $v.object.address.city.$error }"
                                                    >
                                                        <label for="form-field-city">{{ $t('form.city') }}</label>
                                                        <input
                                                            required
                                                            type="text"
                                                            id="form-field-city"
                                                            name="city"
                                                            class="form-control"
                                                            :class="{'loading-spinner--input' : geocodeLoading}"
                                                            :placeholder="$t('form.city.plc')"
                                                            v-model="object.address.city"
                                                            @change="onChangeCity" />
                                                    </div>
                                                    <div class="form-group" v-if="geocodeObject.city.length > 1">
                                                        <select required name="city_list" class="form-control form-control--select" @change="onSelectCity">
                                                            <option value="">{{ $t('form.city.choose')}}</option>
                                                            <option v-for="item in geocodeObject.city" :value="item.city">
                                                                {{ item.city }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="cell medium-12 large-4">
                                                    <div
                                                        class="form-group form-group--required"
                                                        :class="{ 'form-group--error' : $v.object.address.country_code.$error }"
                                                    >
                                                        <label for="form-field-country">{{ $t('customers.country') }}</label>
                                                        <v-select-country
                                                            id="form-field-country"
                                                            v-model="object.address.country_code"
                                                            />
                                                    </div>
                                                </div>

                                                <div class="cell small-12 large-4 u-extra-large-margin--top">
                                                    <label for="form-field-ranking">{{ $t('mixingplants.ranking.label') }}</label>

                                                    <v-select-mixingplant-ranking
                                                        id="form-field-ranking"
                                                        v-model="object.ranking"
                                                    ></v-select-mixingplant-ranking>
                                                </div>

                                                <div class="cell medium-12 u-extra-medium-margin--top">
                                                    <div class="grid-x grid-margin-x">
                                                        <div class="cell small-12">
                                                            <v-ranking-legend></v-ranking-legend>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="cell medium-4">
                                            <div class="form-block">
                                                <div class="form-group">
                                                    <div class="form-control form-control--maps">
                                                        <v-google-map
                                                            :address="objectAddress"
                                                            :resize="!isLoading"
                                                            :lat="object.lat"
                                                            :lon="object.lon"
                                                            :zoom="12"
                                                            :useFitBounds="false"
                                                            @marker="getMarker"
                                                            @noAddressFound="onAddressNotFound"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                                                        <div class="grid-x grid-margin-x">
                                        <div class="cell medium-12"><h4>Kontakt Mischanlage</h4></div>
                                        <div class="cell medium-3">
                                            <div class="form-group">
                                                <label for="form-field-contact_person">Ansprechpartner</label>
                                                <input type="text" id="form-field-contact_person" name="contact_person" class="form-control" placeholder="Name eingeben" v-model="object.contact_person" />
                                            </div>
                                        </div>

                                        <div class="cell medium-3">
                                            <div class="form-group">
                                                <label for="form-field-email">{{ $t('form.email') }}</label>
                                                <input type="text" id="form-field-email" name="email" class="form-control" placeholder="E-Mail eingeben" v-model="object.email" />
                                            </div>
                                        </div>

                                        <div class="cell medium-3">
                                            <div class="form-group">
                                                <label for="form-field-phone">{{ $t('form.phone') }}</label>
                                                <input type="text" id="form-field-phone" name="phone" class="form-control" placeholder="Telefonnummer eingeben" v-model="object.phone" />
                                            </div>
                                        </div>

                                         <div class="cell medium-3">
                                            <div class="form-group">
                                                <label for="form-field-fax">{{ $t('form.fax') }}</label>
                                                <input type="text" id="form-field-fax" name="fax" class="form-control" placeholder="Faxnummer eingeben" v-model="object.fax" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid-x grid-margin-x">
                                        <div class="cell medium-12"><h4>Kontakt Vertrieb</h4></div>
                                        <div class="cell medium-3">
                                            <div class="form-group">
                                                <label for="form-field-contact_person">Ansprechpartner</label>
                                                <input type="text" id="form-field-sales_contact_person" name="sales_contact_person" class="form-control" placeholder="Name eingeben" v-model="object.sales_contact_person" />
                                            </div>
                                        </div>

                                        <div class="cell medium-3">
                                            <div class="form-group">
                                                <label for="form-field-email">{{ $t('form.email') }}</label>
                                                <input type="text" id="form-field-sales_contact_email" name="sales_contact_email" class="form-control" placeholder="E-Mail eingeben" v-model="object.sales_contact_email" />
                                            </div>
                                        </div>

                                        <div class="cell medium-3">
                                            <div class="form-group">
                                                <label for="form-field-phone">{{ $t('form.phone') }}</label>
                                                <input type="text" id="form-field-sales_contact_phone" name="sales_contact_phone" class="form-control" placeholder="Telefonnummer eingeben" v-model="object.sales_contact_phone" />
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import _ from 'lodash';
import GoogleMap from "./../partials/GoogleMap.vue";
import { required } from 'vuelidate/lib/validators';
import PageHeader from './../partials/PageHeader.vue';
import PageLoading from './../partials/PageLoading.vue';
import RankingLegend from './../partials/Rankinglegend.vue';
import FormMessage from './../partials/Forms/FormMessage.vue';
import SelectCountry from './../partials/Forms/SelectCountry.vue';
import ActionButtons from './../partials/Foundation/ActionButtons.vue';
import SelectMixingplantRanking from "./partials/SelectMixingplantRanking.vue";

export default {
    name: "MixingplantCrud",
    data: function() {
      return {
        loading: false,
        loadingError: null,
        mixingplantCreateOrUpdateErrorMessage: null,
        mixingplantCreateOrUpdateSuccessMessage: null,

        object: {
            id: 0,
            address: {
                city: null,
                country_code: 'de',
                housenumber: null,
                region: null,
                street: null,
                zipcode: null,
            },
            contact_person: '',
            email: '',
            phone: '',
            fax: '',
            lat: null,
            lon: null,
            modifiedon: null,
            name: null,
            ranking: null,
        },
        geocodeLoading: false,
        geocodeObject: {
            zipcode: [],
            city: []
        }
      };
    },

    components: {
        vPageHeader: PageHeader,
        vPageLoading: PageLoading,
        vActionButtons: ActionButtons,
        vRankingLegend: RankingLegend,
        vSelectMixingplantRanking: SelectMixingplantRanking,
        vFormMessage: FormMessage,
        vSelectCountry: SelectCountry,
        vGoogleMap: GoogleMap,
    },

    computed: {
        objectAddress () {
            // the backslash \ prevents JavaScript from adding line breaks in the string template literal
            return `\
                ${this.object.address.street ?? ''} \
                ${this.object.address.housenumber ?? ''} \
                ${this.object.address.city ?? ''} \
                ${this.object.address.zipcode ?? ''} \
            `.trim()
        },

        getActionButtons: function () {
            let buttons = [];

            if (this.isCreateMethod) {
                if (this.$store.getters.userHasPermission('mixingplant_create')) {
                    buttons.push({
                        action : 'create'
                    });
                }

                buttons.push({
                    action: 'cancel',
                    router: {
                        name: 'mixingplants',
                    },
                });
            }

            if (this.isUpdateMethod) {
                if (this.$store.getters.userHasPermission('mixingplant_update')) {
                    buttons.push({
                        action: 'save'
                    });
                }

                if (this.object.active) {
                  buttons.push({
                    action : 'deactivate'
                  });
                } else {
                  buttons.push({
                    action : 'activate'
                  });
                }

                buttons.push({
                    action: 'cancel',
                    router: {
                        name: this.isComingFromSearch ? 'search-mixingplants' : 'view-mixingplant',
                        params: { mixingplant: this.$route.params.mixingplant},
                        query: { ...this.$route.query }
                    },
                });
            }

            return buttons;
        },

        isComingFromSearch : function () {
            return this.$route.query.source === 'search';
        },

        isCreateMethod : function () {
            return this.$route.meta.method === 'create';
        },

        isUpdateMethod : function () {
            return this.$route.meta.method === 'update';
        },

        isLoading : function () {
            return this.loading;
        },

        hasLoadingError : function () {
            return this.loadingError !== null;
        },

        getPageTile : function () {
            if (this.object.name) {
                return this.object.name;
            }

            if (this.isCreateMethod) {
                return 'Mischanlage anlegen';
            }

            return 'Mischanlage anlegen';
        },
    },
    // TODO do we need this ? took from customerCrud vue
    watch : {
        '$route' : {
            handler : function () {
                this.checkActionStartState();
            },
            deep    : true
        }
    },

    created: function() {
        this.checkActionStartState();
    },

    methods: {
         onClickAction (action) {
            this.objectError = null;
            this.objectSuccess = null;
            this.objectActivateMessage = null;

            switch (action) {
                case 'create':
                    return this.createMixingPlant();

                case 'save':
                    return this.updateMixingPlant();

                case 'activate':
                    return this.activate();

                case 'deactivate':
                    return this.deactivate();

                default:
                    alert(`Invalid save action "${action}"`)
            }
        },

        /**
         * Check on view creation.
         * If we are updating, get our mixingplant,
         * otherwise we have nothing to get.
         */
        checkActionStartState: function() {
             if (this.isUpdateMethod) {
                this.getMixingPlant();
             }

             if (this.isCreateMethod) {
                this.loading = false;
             }
        },

        createMixingPlant () {
            if (!this.isCreateMethod) {
                this.$helpers.logger("Should create mixing plant when we do not have a create method state. Returning.");
                return;
            }


            this.mixingplantCreateOrUpdateErrorMessage = null;
            this.mixingplantCreateOrUpdateSuccessMessage = null;

            this.$v.object.$reset();
            this.$v.object.$touch();

            if (this.$v.object.$invalid) {
                this.mixingplantCreateOrUpdateErrorMessage = this.$t("form.error_form");

                return;
            }

            this.loading = true;

            this.$api
                .clearParams()
                .post('mixingplants/create', this.object)
                .then(response => {
                    const mixingplant = response.data.data

                    // show success message or redirect or whatever …
                    this.$helpers.logger("Mixingplant successfully created.", mixingplant);
                    this.mixingplantCreateOrUpdateSuccessMessage = this.$t('mixingplants.create.success')

                    // redirect after 1 second: when changing the timeout, change it on the form-message component, too
                    setTimeout(() => {
                        this.$router.push({ name : 'view-mixingplant', params : { mixingplant : mixingplant.id } });
                    }, 1000)
                })
                .catch(error => {
                    // show error message
                    this.$helpers.logger("Error occured while updating.", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        updateMixingPlant () {
            if (!this.isUpdateMethod) {
                this.$helpers.logger("Method called when we do not have an updated method state. Returning. ");
                return;
            }

            this.loading = true;
            this.mixingplantCreateOrUpdateErrorMessage = null;
            this.mixingplantCreateOrUpdateSuccessMessage = null;

            // TODO API endpoint
            this.$api
                .clearParams()
                .post('mixingplants/' + this.$route.params.mixingplant + '/update', this.object)
                .then(response => {
                    this.$helpers.logger("Mixingplant successfully updated", response.data.data);
                    this.mixingplantCreateOrUpdateSuccessMessage = this.$t('mixingplants.update.success')
                })
                .catch(error => {
                    // show error message
                    this.$helpers.logger("Error occured while updating.", error);
                    this.mixingplantCreateOrUpdateErrorMessage = error.response.data.message;

                })
                .finally(() => {
                    this.loading = false;
                });
        },

        activate () {
            this.object.active = 1
            this.updateMixingPlant()
        },

        deactivate () {
            this.object.active = 0
            this.updateMixingPlant()
        },

        /**
         * Get our mixing plant
         */
        getMixingPlant: function() {
            this.loading = true;
            const mixingplantId = this.$route.params.mixingplant;

            this.$api
                .clearParams()
                .get(`mixingplants/${mixingplantId}/get`)
                .then(response => {
                    this.object = response.data.data;
                    // this.$helpers.logger(`Retrieved mixing plant by ID [${mixingplantId}]`, this.object);

                    if (!this.object.address.country_code) {
                        this.object.address.country_code = 'de';
                    }
                })
                .catch(error => {
                    if (error.response !== undefined) {
                        this.loadingError = error.response.data.message;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        onChangeZipcode : _.debounce(function(event) {
            if (event.target.value !== '') {
                this.getGeocodeResult(event.target.value, 'zipcode', 'city');
            }
        }, 500),
        onChangeCity : _.debounce(function(event) {
            if (event.target.value !== '') {
                this.getGeocodeResult(event.target.value, 'city', 'zipcode');
            }
        }, 500),
        onSelectZipcode : function (event) {
            this.object.address.zipcode = event.target.value;

            this.geocodeObject.zipcode = [];
        },
        onSelectCity : function (event) {
            this.object.address.city = event.target.value;

            this.geocodeObject.city = [];
        },

        getGeocodeResult : function (value, type, target) {
            this.geocodeLoading = true;

            this.$geocoder
                .search(value, type)
                .then(response => {
                    let results = response.data.data;

                    if (results.length === 1) {
                        this.object.address[target] = results[0][target];
                    } else {
                        this.geocodeObject[target] = results;
                    }

                    this.geocodeObject[type] = [];
                })
                .catch(error => {
                    this.geocodeObject[target] = [];
                    this.geocodeObject[type] = [];
                })
                .finally(() => {
                    this.geocodeLoading = false;
                });
        },

        getMarker (marker) {
            if (marker) {
                this.object.lat = marker.lat;
                this.object.lon = marker.lng;
            }
        },

        onAddressNotFound (value) {
            if (value) {
                this.object.lat = null;
                this.object.lon = null;
            }
        },
    },

    validations: function () {
        return {
            object: {
                name: {
                    required
                },
                address: {
                    street: {
                        required,
                    },
                    housenumber: {
                        required,
                    },
                    zipcode: {
                        required,
                    },
                    city: {
                        required,
                    },
                    country_code: {
                        required,
                    },
                },
            },
        };
    },
 }

</script>
